import { Bars3Icon, ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useMemo, useState } from "react";
import { useAnalytics } from "../../lib/analytics";
import {
	getBetaTagClassName,
	getEnvironment,
} from "../../lib/utils/environment";
import { BetaFeedbackModal } from "../BetaFeedbackModal";
import { SideMenu } from "../SideMenu";
import styles from "./OnboardingHeader.module.css";

interface OnboardingHeaderProps {
	onBack?: () => void;
	showBackButton?: boolean;
}

export function OnboardingHeader({
	onBack,
	showBackButton = true,
}: OnboardingHeaderProps) {
	const analytics = useAnalytics();
	const [isBetaFeedbackOpen, setIsBetaFeedbackOpen] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const environment = useMemo(() => getEnvironment(), []);
	const betaBadgeClassName = useMemo(
		() => getBetaTagClassName(environment),
		[environment],
	);

	return (
		<>
			<div className={styles.navBar}>
				<button
					type="button"
					onClick={() => {
						analytics.logEvent("onboarding_back_clicked");
						onBack?.();
					}}
					className={styles.backButton}
					aria-label="Go back"
					style={{ visibility: showBackButton ? "visible" : "hidden" }}
				>
					<ChevronLeftIcon className={styles.backIcon} />
				</button>

				<div className={styles.logoWithBeta}>
					<img
						src="/images/era-text-black.png"
						alt="Era"
						className={styles.navLogo}
					/>
					<button
						type="button"
						className={styles[betaBadgeClassName]}
						onClick={() => {
							setIsBetaFeedbackOpen(true);
							analytics.logEvent("beta_tag_click");
						}}
					>
						<div className={styles.betaBadgeText}>Beta</div>
					</button>
				</div>

				<button
					type="button"
					onClick={() => {
						setIsMenuOpen(true);
						analytics.logEvent("onboarding_menu_click");
					}}
					className={styles.menuButton}
					aria-label="Menu"
				>
					<Bars3Icon className={styles.menuIcon} />
				</button>
			</div>

			{/* Beta Feedback Modal */}
			<BetaFeedbackModal
				isOpen={isBetaFeedbackOpen}
				onClose={() => setIsBetaFeedbackOpen(false)}
			/>

			{/* Side Menu - minimal version for onboarding */}
			<SideMenu
				isOpen={isMenuOpen}
				onClose={() => setIsMenuOpen(false)}
				minimal={true}
			/>
		</>
	);
}
